import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const siteUpdateActionTypes = {
  PATCH: type('[site] Patch'),
  PATCH_SUCCESS: type('[site] Patch Success'),
  PATCH_FAIL: type('[site] Patch Fail'),
};

export class PatchSitesAction implements Action {
  readonly type = siteUpdateActionTypes.PATCH;
  // tslint:disable-next-line:no-any
  constructor(public payload?: { api: string[], data: any}) {}
}

export class PatchSitesSuccessAction implements Action {
  readonly type = siteUpdateActionTypes.PATCH_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: {response: any, path: string}) {}
}

export class PatchSitesFailAction implements Action {
  readonly type = siteUpdateActionTypes.PATCH_FAIL;
  constructor(public payload?: string) {}
}
